var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppStore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.729,
    height: 19.155,
    viewBox: "0 0 21.729 19.155",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6455",
    "data-name": "Path 6455",
    d: "M159.185,79.128c.105.276.3.506.389.795a1.465,1.465,0,0,1-.156,1.157,1.4,1.4,0,0,1-2.015.289,2.736,2.736,0,0,1-.467-.613,9.116,9.116,0,0,0-.669-1.185l-.933-1.616-1.766-3.051c-.427-.744-.836-1.5-1.284-2.23a4.879,4.879,0,0,1-.784-2.417,3.926,3.926,0,0,1,.537-1.945,1.6,1.6,0,0,1,.161-.233c.344-.4.334-.4.6.072.174.306.367.6.551.9.4.794.884,1.545,1.335,2.312.278.492.555.987.836,1.478.3.529.622,1.051.918,1.584a.338.338,0,0,0,.341.2c1.039-.008,2.078.009,3.117-.009a1.479,1.479,0,0,1,1.426.768,1.392,1.392,0,0,1-.475,1.72,1.548,1.548,0,0,1-.884.233h-1.6c-.145,0-.233.014-.128.188C158.561,78.063,158.871,78.6,159.185,79.128Z",
    transform: "translate(-139.716 -62.517)",
    fill: "#385f7d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6456",
    "data-name": "Path 6456",
    d: "M25.949,198.5c-.26.439-.517.879-.778,1.315-.084.14-.184.271-.276.405a1.453,1.453,0,0,1-1.867.078c-.11-.078-.132-.207-.229-.284a1.5,1.5,0,0,1-.109-1.381L23.64,197c.078-.131.216-.15.348-.181a2.449,2.449,0,0,1,1.772.233c.17.156.336.311.51.457a.213.213,0,0,1,.047.316C26.182,198.047,26.068,198.275,25.949,198.5Z",
    transform: "translate(-20.816 -181.448)",
    fill: "#385f7d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6457",
    "data-name": "Path 6457",
    d: "M8.47,3.117c-.156-.285-.307-.576-.477-.856a1.789,1.789,0,0,1-.3-1A1.4,1.4,0,0,1,8.8.063,1.352,1.352,0,0,1,10.237.71c.2.33.389.67.587,1.025A7.858,7.858,0,0,0,11.381.78,1.309,1.309,0,0,1,12.825.062,1.354,1.354,0,0,1,13.98,1.354a2.226,2.226,0,0,1-.032.37c-.267.667-.705,1.244-1.02,1.883-.807,1.36-1.622,2.714-2.372,4.107a1.113,1.113,0,0,0-.068.091q-1.2,2.072-2.4,4.146c-.03.054-.093.1-.045.19,1.306,0,2.616.009,3.926-.005a2.039,2.039,0,0,1,1.283.376,2,2,0,0,1,.583,2.088.31.31,0,0,1-.348.258Q7.494,14.848,1.5,14.851A1.4,1.4,0,0,1,.01,13.226a1.025,1.025,0,0,1,.184-.438,1.545,1.545,0,0,1,1.4-.655c1,.023,2,0,3,.011a.356.356,0,0,0,.364-.212c.41-.735.832-1.462,1.251-2.193Q7.377,7.718,8.55,5.7c.215-.366.429-.733.648-1.1a.224.224,0,0,0-.005-.264C8.946,3.93,8.712,3.523,8.47,3.117Z",
    transform: "translate(-0.001 -0.035)",
    fill: "#385f7d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppStore);
export default __webpack_public_path__ + "static/media/App-Store.b764295992ee251437464867990e6775.svg";
export { ForwardRef as ReactComponent };